<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.product')"
    :onFetchData="onFetchData"
    ref="sourcePage"
    resource="products"
    :batch-actions="batchActions"
  >
    <template v-slot:action>
      <bean-import-button
        can='products.create'
        buttonText="导入"
        :tooltipText="$t('importTemplate')"
        url="/products/import"
        :fileChangeHandler="handleImprtFileChange"
      >
      </bean-import-button>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/products.js';
import { columnsExtend as variantColumnsExtend, } from '../admin_entities/variant_detail.js';
// import { columnsExtend as variantCompanyRelationsColumnsExtend, } from '../admin_entities/variant_company_relation_detail.js';
import { abilityService } from 'beans-admin-plugin';
import _ from 'lodash';
import ManufactureEditModal from './products-manufacture-edit-modal.vue';
import ManufactureFlowsTable from './products-manufacture-flows-table.vue';

@Component({
  components: {
    ManufactureEditModal
  }
})
export default class Products extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  sizeOptionValues = []
  variantTableValues = {}
  companies = []
  record = {}

  get roleKind() {
    return _.get(this.$root.user, 'current_role.role.kind');
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'style_number_cont',
      'number_cont',
      'product_category_id_eq',
      'supplier_name_cont',
      'vc_name_cont',
      {
        prop: 'created_at_date_range',
        label: '创建时间段',
        renderCell: {
          component: 'dateTimePicker',
          props: {
            type: 'daterange',
            rangeSeparator: '至',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            valueFormat: 'yyyy-MM-dd'
          }
        }
      }
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const currentUser = this.$root.user

    const array = [
      type === 'show' && 'id',
      'image',
      {
        prop: 'product_design.main_image',
        label: `${this.$t('model.productDesign')}${this.$t('productDesign.mainImage')}`,
        width: 120,
        renderCell: 'storageAttachment'
      },
      'style_number',
      {
        key: 'semi_style_number',
        label: this.$t('product.semiStyleNumber'),
        renderCell: (h, { props: { value } }) => {
          return <div>{value}</div>
        }
      },
      'number',
      'product_category',
      'supplier_name',
      'vc_name',
      currentUser.abilities.read_product_cost_price && 'cost_price',
      'sales_price',
      'return_period',
      'release_at',
      'fabric_cutting_count',
      'creator',
      type === 'show' && 'color_option_values',
      type === 'show' && 'size_option_values',
      type === 'show' && 'min_order_qty',
      type === 'show' && {
        prop: 'variants',
        label: this.$t('product.variants'),
        renderCell: (h, { props: { value } }) => {
          const variantsColumns = variantColumnsExtend([
            'color_option_value',
            'size_option_value',
            'sku',
            // abilityService.can('variants.update') && {
            //   prop: 'variant_company_relations',
            //   label: '费用',
            //   minWidth: 300,
            //   renderCell: (h, { props: { value } }) => {
            //     const variantCompanyRelationsColumns = variantCompanyRelationsColumnsExtend([
            //       'company',
            //       'cost',
            //     ])

            //     return <bean-table style={{ width: '100%' }} value={value} columns={variantCompanyRelationsColumns} height={null} actions={[]} />;
            //   }
            // },
            {
              prop: 'manufacture_flows',
              minWidth: 800,
              label: '加工费',
              renderCell: (h, { props: { value } }) => {
                return <ManufactureFlowsTable data={value} />;
              }
            }
          ].filter(Boolean))

          let actions = []

          if (abilityService.can('variants.update')) {
            actions = ({ row }) => {
              // const dialogFormValue = {
              //   variant_company_relation_table_attributes: _.map(this.companies, (company) => {
              //     const relation = _.find(row.variant_company_relations, (relation) => (relation.company_id === company.id)) || {}

              //     return {
              //       company_name: company.name,
              //       company_id: company.id,
              //       cost: relation.cost
              //     }
              //   })
              // }

              return [
                // {
                //   component: 'dialogFormButton',
                //   props: {
                //     label: '编辑采购成本',
                //     can: 'variants.update',
                //     value: dialogFormValue,
                //     columns: [{
                //       prop: 'variant_company_relation_table_attributes',
                //       label: '',
                //       renderCell: 'cost-edit-table'
                //     }],
                //     submitHandler: async (val) => {
                //       await this.$autoLoading(this.$request.put(`/variants/${row.id}`, val));
                //       this.$message.success(this.$t('operateSuccess'));
                //       this.$refs.sourcePage.fetchData();
                //     }
                //   }
                // },
                // 编辑加工费
                abilityService.can('variants.update') && (
                  () => <ManufactureEditModal row={row} onReload={() => this.$refs.sourcePage.fetchData()} />
                ),
              ].filter(Boolean)
            }
          }

          return <bean-table style={{}} value={value} columns={variantsColumns} actions={actions} />;
        }
      },
      type === 'show' && _.has(this.record, 'product_design_cost_price') && {
        prop: 'product_design_cost_price',
        label: this.$t('productDesign.costPrice')
      },
      type === 'show' && _.has(this.record, 'product_design_settlement_cost') && {
        prop: 'product_design_settlement_cost',
        label: this.$t('productDesign.settlementCost')
      },
      type === 'show' && _.has(this.record, 'product_design_paper_pattern_files') && {
        prop: 'product_design_paper_pattern_files',
        label: this.$t('productDesign.paperPatternFiles'),
        renderCell: 'storageAttachment'
      },
      type === 'show' && _.has(this.record, 'product_design_cost_detail_files') && {
        prop: 'product_design_cost_detail_files',
        label: this.$t('productDesign.costDetailFiles'),
        renderCell: 'storageAttachment'
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type, change }) {
    const currentUser = this.$root.user

    const array = [
      {
        key: 'image',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 300x300`,
          props: {
            cropper: {
              width: 300,
              height: 300,
            }
          }
        }
      },
      'style_number',
      'number',
      'product_category_id',
      'supplier_name',
      'vc_name',
      currentUser.abilities.update_product_cost_price && 'cost_price',
      'sales_price',
      'return_period',
      'release_at',
      'fabric_cutting_count',
      {
        prop: 'color_option_value_list',
        label: '颜色',
        renderCell: {
          component: 'select',
          props: {
            multiple: true,
            allowCreate: true,
            defaultFirstOption: true,
            options: _.map(data.color_option_values, (item) => ({ label: item.name, value: item.name })),
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/option_values/read_options', { per_page: 100, option_type_kind_eq: 'color' });
              return data.map(item => ({ value: item.name, label: item.name }));
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/option_values/read_options', { keyword, option_type_kind_eq: 'color' });
              return data.map(item => ({ value: item.name, label: item.name }));
            }
          },
          on: {
            change: (value) => {
              change({
                color_option_value_list: value,
                variant_table_attributes: this.setVariantTableAttributes(value, data.size_option_value_ids)
              })
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        key: 'size_option_value_ids',
        renderCell: {
          props: {
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/option_values/read_options', { per_page: 100, option_type_kind_eq: 'size' });
              return data.map(item => ({ value: item.id, label: item.name }));
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/option_values/read_options', { keyword, option_type_kind_eq: 'size' });
              return data.map(item => ({ value: item.id, label: item.name }));
            }
          },
          on: {
            change: (value) => {
              if (value) {
                value.sort((a, b) => {
                  const aPosition = _.find(this.sizeOptionValues, (optionValue) => optionValue.id === a).position

                  if (aPosition === null) {
                    return 99999999
                  }

                  const bPosition = _.find(this.sizeOptionValues, (optionValue) => optionValue.id === b).position

                  if (bPosition === null) {
                    return -99999999
                  }

                  return aPosition - bPosition
                })
              }

              change({
                size_option_value_ids: value,
                variant_table_attributes: this.setVariantTableAttributes(data.color_option_value_list, value)
              })
            }
          }
        }
      },
      'min_order_qty',
      {
        prop: 'variant_table_attributes',
        label: 'SKU',
        renderCell: (h, { props: { scope: { row } } }) => {
          return (
            <el-table data={row.variant_table_attributes} border style="width: 100%">
              <el-table-column prop="color" label="颜色" />
              <el-table-column prop="size" label="尺寸" />
              <el-table-column label="SKU" scopedSlots={{ default: (scope) => (<el-input value={row.variant_table_attributes[scope.$index].sku} onInput={value => this.handleVariantChange(value, row, 'sku', scope.$index, change)} />) }} />
            </el-table>
          )
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  async onFetchData({ type, resource }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get(`/${resource}`, { params: { ...this.$route.query } });
      return {
        data,
        pagination
      }
    }

    if (type === 'new' || type === 'edit') {
      this.sizeOptionValues = (await this.$request.get('/option_values/read_options', { per_page: 1000, option_type_kind_eq: 'size' })).data;
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/${resource}/${this.$route.params.id}`);

      if (type === 'edit') {
        _.each(data.variants, (variant) => {
          this.variantTableValues[`${variant.color_option_value.name}:${variant.size_option_value.name}`] = {
            sku: variant.sku
          }
        })

        data.variant_table_attributes = this.setVariantTableAttributes(data.color_option_value_list, data.size_option_value_ids)
      }

      if (type === 'show') {
        this.record = data
        if (abilityService.can('variants.update')) {
          this.companies = (await this.$request.get('/companies/read_options', { page: 0 }));
        }
      }

      return { data };
    }

    if (type === 'new') {
      if (this.$route.query.create_by_product_design_id) {
        const productDesign = await this.$request.get(`/product_designs/${this.$route.query.create_by_product_design_id}`)
        let data = {
          number: productDesign.number,
          color_option_value_list: _.map(productDesign.product_design_item_table_attributes, (item) => item.color_option_value.name),
          size_option_value_ids: _.map(productDesign.product_design_item_table_attributes, (item) => item.size_option_value_id)
        }

        data.variant_table_attributes = this.setVariantTableAttributes(data.color_option_value_list, data.size_option_value_ids)

        return { data }
      }

      return { variant_table_attributes: [] }
    }
  }

  setVariantTableAttributes(colorOptionValues, sizeOptionValueIds) {
    return _.flatten(
      _.map(colorOptionValues, (colorOptionValue) => (
        _.map(sizeOptionValueIds, (sizeOptionValueId) => {
          const size = _.find(this.sizeOptionValues, (optionValue) => (optionValue.id === sizeOptionValueId)).name
          return {
            color: colorOptionValue,
            size: size,
            size_option_value_id: sizeOptionValueId,
            sku: _.get(this.variantTableValues, `${colorOptionValue}:${size}.sku`, ''),
          }
        })
      ))
    )
  }

  handleVariantChange(value, data, column, index, change) {
    let variant_table_attributes = data.variant_table_attributes
    variant_table_attributes[index][column] = value

    const row = variant_table_attributes[index]
    this.variantTableValues[`${row.color}:${row.size}`][column] = value

    change({ variant_table_attributes: variant_table_attributes })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const abilities = _.get(row, 'abilities', {});

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'products.edit', params: { id: row.id } }
        }
      },
      abilities.sync && {
        component: 'confirmButton',
        props: {
          label: '同步聚水潭数据',
          type: 'primary',
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/products/${row.id}/refresh_by_jushuitan_data`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: '推送到聚水潭',
          can: 'products.update',
          type: 'primary'
        },
        on: {
          confirm: async () =>  {
            await this.$autoLoading(this.$request.put(`/products/${row.id}/push_to_jushuitan`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'products.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async upload(file) {
    const form = new FormData();
    form.append('file_message', file);
    const requestConfig = {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
      return_res: true,
      // 1小时超时
      timeout: 1 * 60 * 60 * 1000
    }
    const result = await this.$request.post('/products/import', form, requestConfig);
    if (result.headers['x-error-message']) {
      throw new Error(decodeURIComponent(result.headers['x-error-message']));
    }
    //if (+result.headers['x-error-count'] > 0) {
    //  this.download(new Blob([result.data]), `${this.$t('bean.error_massage')}.xlsx`);
    //  throw new Error(this.$t('bean.importFail'));
    //}
  }

  // 为了支持导入成功之后刷新页面
  async handleImprtFileChange(e) {
    const file = e.target.files[0];
    this.importing = true;
    let toastInstance = null;
    toastInstance = this.$message.info({
      message: '导入中...请不要刷新页面',
      duration: 0,
      showClose: true
    });
    try {
      await this.upload(file);
      this.$message.success(this.$t('bean.importSuccess'));
      // this.$router.push({ name: 'products.index' });
      this.$refs.sourcePage.fetchData()
    } catch (e) {
      const msg = e.message || this.$t('bean.importFail');
      this.$message.error({
        message: msg,
        showClose: true,
        duration: 0
      });
    } finally {
      this.importing = false;
      if (toastInstance) {
        toastInstance.close();
      }
    }
    e.target.value = '';
  }

  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      let result
      const options = { timeout: 30 * 60 * 1000 }
      if (selection.length === 0) {
        result = await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query }, options));
      } else {
        result = await this.$autoLoading(this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) }, options));
      }

      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = result.url;
      a.download = '商品信息.xlsx';
      a.click();
      document.body.removeChild(a);
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>导出</el-button>
    ];
  }
}

export const route = [
  {
    path: '/products',
    name: 'products.index',
    component: Products,
    props: {
      type: 'index',
    }
  },
  {
    path: '/products/new',
    name: 'products.new',
    component: Products,
    props: {
      type: 'new',
    }
  },
  {
    path: '/products/:id',
    name: 'products.show',
    component: Products,
    props: {
      type: 'show',
    }
  },
  {
    path: '/products/:id/edit',
    name: 'products.edit',
    component: Products,
    props: {
      type: 'edit'
    }
  }
]
</script>
